import classNames from 'classnames'

import { AIButtonIconGradientIdPrefix } from '../AIButton.constants'
import { AIButtonIcon } from '../AIButtonIcon'

import * as styles from './AIButtonIconGrey.module.css'

function AIButtonIconGrey({
  className = styles.aiButtonIconGrey,
  isLoading,
  ...restProps
}) {
  return (
    <AIButtonIcon
      {...restProps}
      className={classNames(className, {
        [styles.loading]: isLoading,
      })}
      gradientIdPrefix={AIButtonIconGradientIdPrefix.IconGrey}
      isLoading={isLoading}
    />
  )
}

export default AIButtonIconGrey
